// extracted by mini-css-extract-plugin
module.exports = {"container":"_82e3db2ea0--container--v67NC","phone":"_82e3db2ea0--phone--vUQQK","tablet":"_82e3db2ea0--tablet--uLIXK","features":"_82e3db2ea0--features--yqnwt"};